import { Descriptions } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetSeo = (props) => {
  const {
    title = 'lol',
    description = 'lol1',
    url = 'lol3',
    image = 'lol4',
  } = props;
  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta name='title' content={title} />
        <meta name='description' content={description} />

        <meta property='og:url' content={url} />
        <meta property='og:type' content='article' />
        <meta property='og:title' content={title} />
        <meta property='og:description' content={description} />
        <meta property='og:image' content={image} />
        <meta property='og:image:width' content='512' />
        <meta property='og:image:height' content='512' />
        <meta property='og:site_name' content='Interact' />
        <meta property='og:locale' content='en_US' />

        <meta name='twitter:domain' content='https://interact.rajchandra.me' />
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:site' content='@raj_chandra3' />
        <meta name='twitter:creator' content='@raj_chandra3' />
        <meta name='tweetmeme-title' content={title} />
        <meta name='twitter:title' content={title} />
        <meta name='twitter:url' content={url} />
        <meta name='twitter:description' content={description} />
        <meta name='twitter:image' content={image} />
      </Helmet>
    </>
  );
};

export default HelmetSeo;
